import type { EdpReviewer } from '../../api/employeeDocsTypes.js';

/**
 * Tick every VGS user who may QA the package. Any one of them can accept or
 * reject items and release the package; all of them are emailed on submission.
 */
export function ReviewerPicker({
  reviewers,
  selected,
  onChange,
  idPrefix,
}: {
  reviewers: EdpReviewer[];
  selected: string[];
  onChange: (next: string[]) => void;
  idPrefix: string;
}) {
  if (reviewers.length === 0) {
    return (
      <p className="text-sm text-slate-500">
        No VGS user can review employee documents yet. Grant the review permission under
        Administration.
      </p>
    );
  }
  return (
    <div className="grid gap-1 sm:grid-cols-2" role="group" aria-label="QA reviewers">
      {reviewers.map((entry) => {
        const id = `${idPrefix}-${entry.id}`;
        return (
          <label
            key={entry.id}
            htmlFor={id}
            className="flex items-start gap-2 text-sm text-slate-800"
          >
            <input
              id={id}
              type="checkbox"
              className="mt-0.5"
              checked={selected.includes(entry.id)}
              onChange={(e) =>
                onChange(
                  e.target.checked
                    ? [...selected, entry.id]
                    : selected.filter((value) => value !== entry.id),
                )
              }
            />
            <span>
              {entry.fullName}
              <span className="text-xs text-slate-500"> · {entry.email}</span>
            </span>
          </label>
        );
      })}
    </div>
  );
}
